import React, { useRef, forwardRef } from 'react'
import { Carousel } from 'react-bootstrap'
import { Link, useParams } from 'react-router-dom'
import './style/Slider.scss'
import * as t from 'counterpart'
export default forwardRef(function (props, ref) {
    let { indicators, fade, slides } = props
    const { store } = useParams()
    const carouselRef = useRef(null)
    const carouselPos = useRef(0)

    props = {
        ...props,
        className: 'slider-block ' + props.className,
    }

    try {
        slides = JSON.parse(slides)
    } catch (e) {
        console.log('Slider parse error:', e)
    }

    delete props.slides
    delete props.indicators
    delete props.fade

    return (
        <div {...props} ref={ref}>
            <Carousel
                ref={carouselRef}
                controls={props.controls !== false}
                indicators={indicators !== false}
                fade={fade}
                style={{ direction: 'ltr' }}
                onTouchStartCapture={(e) => {
                    const t = e.touches[0]
                    carouselPos.current = t.clientX
                }}
                onTouchEndCapture={(e) => {
                    if (t('dir') !== 'rtl') {
                        return
                    }

                    e.stopPropagation()
                    if (e.changedTouches[0].clientX < carouselPos.current) {
                        carouselRef.current.prev(e)
                    } else {
                        carouselRef.current.next(e)
                    }
                }}
            >
                {(slides || []).map((slide, i) => {
                    let props = {}
                    if (slide.link) {
                        if (slide.link.includes('http')) {
                            props = { as: 'a', href: slide.link, target: '_blank' }
                        } else {
                            props = { as: Link, to: '/' + store + slide.link }
                        }
                    }

                    return (
                        <Carousel.Item key={i} style={slide.style} {...props}>
                            {(slide.images || []).map((image, i) => (
                                <img
                                    key={i}
                                    src={image.path}
                                    alt={slide.title || t('More')}
                                    style={image.style}
                                />
                            ))}
                            <Carousel.Caption>
                                <h3>{slide.title}</h3>
                                <p>{slide.text}</p>
                            </Carousel.Caption>
                        </Carousel.Item>
                    )
                })}
            </Carousel>
        </div>
    )
})
